import { Gift, Check } from "lucide-react";
import Logo from "@/components/Logo";

export default function StampCard({ stamps = 0, freeCredits = 0, userName = "" }) {
  const slots = Array.from({ length: 5 }, (_, i) => i < stamps);

  return (
    <div
      data-testid="loyalty-stamp-card"
      className="relative w-full max-w-md mx-auto aspect-[1.6/1] rounded-2xl bg-gradient-to-br from-zinc-900 via-zinc-950 to-black border border-white/10 p-6 flex flex-col justify-between overflow-hidden shadow-2xl gold-glow"
    >
      {/* Decorative gradient */}
      <div className="absolute -top-20 -right-20 w-56 h-56 bg-primary/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-10 w-48 h-48 bg-primary/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative flex items-start justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-1">
            VIP Treuekarte
          </div>
          <div className="font-heading text-xl text-white">
            Mo's <span className="text-gradient-gold">Glanzwerk</span>
          </div>
          {userName && (
            <div className="text-xs text-zinc-400 mt-1" data-testid="loyalty-card-name">
              {userName}
            </div>
          )}
        </div>
        <Logo size={48} />
      </div>

      <div className="relative flex items-center justify-between gap-2 sm:gap-3 mt-4">
        {slots.map((filled, i) => (
          <div
            key={i}
            data-testid={`stamp-slot-${i}`}
            className={
              filled
                ? "w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary flex items-center justify-center shadow-[0_0_20px_rgba(245,200,80,0.4)] text-black"
                : "w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-dashed border-zinc-700 bg-zinc-950/50 flex items-center justify-center text-zinc-600"
            }
          >
            {filled ? <Check className="w-5 h-5" strokeWidth={3} /> : <span className="text-xs">{i + 1}</span>}
          </div>
        ))}
        <div
          data-testid="free-stamp-slot"
          className="w-14 h-14 sm:w-16 sm:h-16 rounded-full border-2 border-primary/60 bg-primary/10 flex items-center justify-center flex-shrink-0 text-primary ml-1"
        >
          <Gift className="w-6 h-6" />
        </div>
      </div>

      <div className="relative flex items-center justify-between text-xs">
        <div className="text-zinc-500">
          {stamps}/5 bis zur Gratis-Aufbereitung
        </div>
        {freeCredits > 0 && (
          <div
            data-testid="free-credits-badge"
            className="px-3 py-1 rounded-full bg-primary text-primary-foreground font-semibold"
          >
            {freeCredits}× Gratis verfügbar
          </div>
        )}
      </div>
    </div>
  );
}
